import { useQuery } from '@tanstack/react-query';
import { API } from '../utils/Api';
import { API as ZiphyAPI } from '../utils/ZiphyAPI';
import { AuthData } from '../models/ziphy';
import { Client } from '../models/core';
import { Role } from '../models/ziphy';
import { analytics } from '../utils/analytics/zipAnalytics';

const fetchClients = async (): Promise<Client[]> => {
    const authItem = window.localStorage.getItem('auth');
    const auth = authItem ? (JSON.parse(authItem) as AuthData) : null;
    API.token = auth?.accessToken?.value || '';
    ZiphyAPI.token = API.token;

    const isAdmin = auth?.roles?.find((r: Role) => r.role == 'admin') != undefined;
    if (isAdmin) {
        return (await API.getClients(undefined, [['name', 1]])).items;
    }

    const seenPracticeIds = new Set<number>();
    (auth?.roles || []).forEach((r: Role) => {
        if ((r.role == 'practice_admin' || r.role == 'dispatcher')) {
            if(r.serviced_practice_ids) {
                r.serviced_practice_ids?.forEach((e: number) => {
                    if(!seenPracticeIds.has(e)) {
                        seenPracticeIds.add(e);
                    }
                })
            } else if(r.practice_id && !seenPracticeIds.has(r.practice_id)) {
                seenPracticeIds.add(r.practice_id);
            }
        }
    });

    const practiceArray = Array.from(seenPracticeIds).map((id) => id + '');
    const filter = { practiceId: { $in: practiceArray } }

    const clients = (await API.getClients(filter).catch((error: Error) => {
            console.error(`Error Retrieving Clients: ${error}`)
            analytics.error('client_auth_error', {message:error?.message || 'client_auth_error'}, true);
        }))?.items || [];
    return clients;
};

export const useClientsQuery = () => {
    return useQuery<Client[], Error>({
        queryKey: ['clients'],
        queryFn: fetchClients,
        staleTime:8*(60*1000)
    });
};